module.exports = __webpack_public_path__ + "img/news.4f2c87b6.svg";